import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaImage, FaVideo, FaPlay, FaExpand, FaArrowLeft, FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import MediaLightbox from './MediaLightbox';

function EventGallery() {
  const navigate = useNavigate();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  // تصاویر همایش روز اول - ۲۱ آبان ۱۴۰۴
  const day1Images = [
    { type: 'image', url: 'https://i.postimg.cc/NjMPzMs8/IMG-20251113-WA0000.jpg', alt: 'همایش ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/9QFvHbpy/IMG-20251113-WA0001.jpg', alt: 'همایش ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/JzpCsvnq/IMG-20251113-WA0002.jpg', alt: 'همایش ۲۱ آبان', event: 'day1' },
    { type: 'image', url: 'https://i.postimg.cc/jdQbbLrs/IMG-20251113-WA0003.jpg', alt: 'همایش ۲۱ آبان', event: 'day1' }
  ];

  // تصاویر همایش روز دوم - ۲۸ آبان ۱۴۰۴ (کمپ باور)
  const day2Images = [
    { type: 'image', url: 'https://i.postimg.cc/gJNSxJjL/IMG-20251119-WA0005.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/MTdPnTHV/IMG-20251130-WA0001.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/MTdPnTH7/IMG-20251130-WA0002.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' },
    { type: 'image', url: 'https://i.postimg.cc/qRjbNRq2/IMG-20251130-WA0003.jpg', alt: 'روز دوم کمپ باور - ۲۸ آبان', event: 'day2' }
  ];

  // تصاویر کمپ ۱۲ آذر و اختتامیه
  const day3Images = [
    { type: 'image', url: 'https://i.postimg.cc/CxLvP2NG/IMG-20251203-WA0014.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/6p5HjP0G/IMG-20251203-WA0015.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/kXy1yCx4/IMG-20251203-WA0017.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/CL0rD5fS/IMG-20251203-WA0019.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/ryxYKxsr/IMG-20251203-WA0021.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/8kMnjMcw/IMG-20251203-WA0023.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/VLwZMv04/IMG-20251203-WA0025.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/SN418RYD/IMG-20251203-WA0027.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/J43gdZCv/IMG-20251203-WA0029.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/3xJLSqBC/IMG-20251203-WA0031.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/vZq0pv2y/IMG-20251203-WA0033.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/ZqWwZyXT/IMG-20251203-WA0035.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' },
    { type: 'image', url: 'https://i.postimg.cc/RZsgjTp9/IMG-20251203-WA0037.jpg', alt: 'کمپ ۱۲ آذر و اختتامیه', event: 'day3' }
  ];

  const eventVideos = [
    { type: 'video', url: 'https://customer-assets.emergentagent.com/job_24dae199-66e7-4e77-8ffd-deeb363828c0/artifacts/sijbu381_VID-20251114-WA0009.mp4', alt: 'ویدیو همایش ۲۱ آبان' },
  ];

  const allMedia = [...day1Images, ...day2Images, ...day3Images, ...eventVideos];
  const previewMedia = allMedia.slice(0, 8);

  const handleMediaClick = (index) => {
    setSelectedIndex(index);
    setLightboxOpen(true);
  };

  const totalImages = day1Images.length + day2Images.length + day3Images.length + 14 + 7; // 14 more from day1, 7 more from day2
  const totalVideos = 4;

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="max-w-7xl mx-auto mb-12 md:mb-16"
      >
        <div className="bg-gradient-to-br from-white via-purple-50/50 to-pink-50/50 dark:from-gray-800 dark:via-gray-700 dark:to-gray-800 rounded-3xl p-4 sm:p-6 md:p-8 shadow-2xl border-2 border-purple-200/50 dark:border-purple-700/50">
          {/* Header - Compact and Modern */}
          <div className="text-center mb-6 md:mb-8">
            <motion.div
              initial={{ scale: 0.9 }}
              whileInView={{ scale: 1 }}
              transition={{ duration: 0.5 }}
              className="inline-block"
            >
              <div className="inline-flex items-center gap-2 md:gap-3 bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 dark:from-purple-500 dark:via-pink-500 dark:to-rose-500 text-white px-4 md:px-6 py-2 md:py-3 rounded-2xl shadow-xl shadow-purple-500/30 mb-3">
                <FaImage className="text-xl md:text-2xl" />
                <h3 className="text-xl md:text-2xl lg:text-3xl font-bold">گالری تصاویر و ویدیوها</h3>
              </div>
            </motion.div>
            <p className="text-sm md:text-base lg:text-lg text-gray-600 dark:text-gray-400">
              خاطرات زیبای جشنواره امید
            </p>
          </div>

          {/* Event Tags */}
          <div className="flex flex-wrap justify-center gap-3 mb-6">
            <div className="inline-flex items-center gap-2 bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 px-4 py-2 rounded-xl text-sm font-medium">
              <FaCalendarAlt />
              <span>۲۱ آبان - همایش افتتاحیه</span>
            </div>
            <div className="inline-flex items-center gap-2 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 px-4 py-2 rounded-xl text-sm font-medium">
              <FaCalendarAlt />
              <span>۲۸ آبان - کمپ باور</span>
            </div>
            <div className="inline-flex items-center gap-2 bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 px-4 py-2 rounded-xl text-sm font-medium">
              <FaCalendarAlt />
              <span>۱۲ آذر - کمپ و اختتامیه</span>
            </div>
          </div>

          {/* Horizontal Scrolling Gallery - Optimized for Mobile */}
          <div className="relative">
            {/* Scroll Container - Smooth Horizontal Scrolling */}
            <div 
              className="flex gap-3 md:gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scroll-smooth"
              style={{
                scrollbarWidth: 'thin',
                scrollbarColor: '#a855f7 #e9d5ff',
                WebkitOverflowScrolling: 'touch'
              }}
            >
              {/* Show limited items on mobile, all on desktop */}
              {previewMedia.map((item, index) => (
                <motion.div
                  key={`${item.url}-${index}`}
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                  onClick={() => handleMediaClick(index)}
                  className="relative flex-shrink-0 w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 cursor-pointer group overflow-hidden rounded-xl md:rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 snap-start"
                  data-testid={`gallery-item-${index}`}
                >
                  {item.type === 'image' ? (
                    <>
                      <img
                        src={item.url}
                        alt={item.alt}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        loading="lazy"
                      />
                      {/* Image Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                        <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                          <div className="bg-white/20 backdrop-blur-md rounded-full p-3 md:p-4">
                            <FaExpand className="text-white text-lg md:text-xl" />
                          </div>
                        </div>
                      </div>
                      {/* Event Badge */}
                      <div className={`absolute top-2 right-2 backdrop-blur-sm text-white px-2 py-1 rounded-lg text-xs font-bold flex items-center gap-1 ${
                        item.event === 'day1' ? 'bg-purple-600/90' : item.event === 'day2' ? 'bg-blue-600/90' : 'bg-emerald-600/90'
                      }`}>
                        <FaImage className="text-xs" />
                        {item.event === 'day1' ? '۲۱ آبان' : item.event === 'day2' ? '۲۸ آبان' : '۱۲ آذر'}
                      </div>
                    </>
                  ) : (
                    <>
                      <video
                        src={item.url}
                        className="w-full h-full object-cover"
                        preload="metadata"
                      />
                      {/* Video Overlay */}
                      <div className="absolute inset-0 bg-black/50 group-hover:bg-black/70 transition-colors duration-300 flex items-center justify-center">
                        <div className="transform scale-90 group-hover:scale-100 transition-transform duration-300">
                          <div className="bg-white/20 backdrop-blur-md rounded-full p-4 md:p-5">
                            <FaPlay className="text-white text-2xl md:text-3xl mr-1" />
                          </div>
                        </div>
                      </div>
                      {/* Video Badge */}
                      <div className="absolute top-2 right-2 bg-red-600/90 backdrop-blur-sm text-white px-2 py-1 rounded-lg text-xs font-bold flex items-center gap-1">
                        <FaVideo className="text-xs" />
                        ویدیو
                      </div>
                    </>
                  )}
                </motion.div>
              ))}
            </div>

            {/* View All Button */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="flex justify-center mt-6"
            >
              <motion.button
                onClick={() => navigate('/gallery')}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center gap-3 px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 hover:from-purple-700 hover:via-pink-700 hover:to-rose-700 text-white rounded-2xl font-bold text-base md:text-lg shadow-xl shadow-purple-500/30 hover:shadow-2xl transition-all"
                data-testid="view-all-gallery-btn"
              >
                <FaImage className="text-xl" />
                مشاهده همه تصاویر و ویدیوها ({totalImages + totalVideos})
                <FaArrowLeft className="text-lg" />
              </motion.button>
            </motion.div>
          </div>

          {/* Gallery Stats - Compact Footer */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="mt-6 md:mt-8 pt-4 md:pt-6 border-t-2 border-purple-200/50 dark:border-purple-700/50"
          >
            <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-center">
              <div className="bg-white/60 dark:bg-gray-700/60 rounded-xl px-4 py-2 md:px-6 md:py-3 shadow-md">
                <div className="flex items-center gap-2 text-purple-600 dark:text-purple-400">
                  <FaImage className="text-lg md:text-xl" />
                  <div>
                    <p className="text-xl md:text-2xl font-bold">{totalImages}</p>
                    <p className="text-xs md:text-sm">تصویر</p>
                  </div>
                </div>
              </div>
              <div className="bg-white/60 dark:bg-gray-700/60 rounded-xl px-4 py-2 md:px-6 md:py-3 shadow-md">
                <div className="flex items-center gap-2 text-pink-600 dark:text-pink-400">
                  <FaVideo className="text-lg md:text-xl" />
                  <div>
                    <p className="text-xl md:text-2xl font-bold">{totalVideos}</p>
                    <p className="text-xs md:text-sm">ویدیو</p>
                  </div>
                </div>
              </div>
              <div className="bg-white/60 dark:bg-gray-700/60 rounded-xl px-4 py-2 md:px-6 md:py-3 shadow-md">
                <div className="flex items-center gap-2 text-blue-600 dark:text-blue-400">
                  <FaCalendarAlt className="text-lg md:text-xl" />
                  <div>
                    <p className="text-xl md:text-2xl font-bold">۳</p>
                    <p className="text-xs md:text-sm">رویداد</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>

      <MediaLightbox
        items={allMedia}
        initialIndex={selectedIndex}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
      />
    </>
  );
}

export default EventGallery;
